export const SEASONS_LOADING = 'SEASONS_LOADING';
export const SEASONS_CURRENT_SEASON = 'SEASONS_CURRENT_SEASON';
export const SEASONS_LIST_SEASONS = 'SEASONS_LIST_SEASONS';
